import FilterBar from '../../components/FilterBar';
import { TextField } from '@mui/material';
import { Autocomplete } from '@mui/material';
import LinksToggleSwitch from '../../components/LinksToggleSwitch';
import { AnalyzerLinksFilter } from './linksTypes';
import { useGetAllTypesQuery } from '../../api/api-hooks';

interface Props {
  filters: AnalyzerLinksFilter;
  setFilters: React.Dispatch<any>;
  initialFilters: AnalyzerLinksFilter;
}

const AnalyzerLinksFilterBar = ({
  filters,
  setFilters,
  initialFilters,
}: Props) => {
  const { data: types } = useGetAllTypesQuery({});
  if (types === undefined) return null;
  return (
    <>
      <FilterBar
        filters={filters}
        setFilters={setFilters}
        initialFilters={initialFilters}
        filterConstraintChecker={() => true}
        children={(
          handler: (event: any, value?: any, label?: string) => void
        ) => [
          <LinksToggleSwitch startingOption='Hardware' />,
          <Autocomplete
            onChange={(event, value) => {
              handler(event, value, 'hardwareType');
            }}
            value={filters.hardwareType}
            options={types}
            getOptionLabel={(type) => type.typeName}
            style={{ width: 200 }}
            renderInput={(params) => (
              <TextField
                {...params}
                label='Filter By Type'
                variant='outlined'
              />
            )}
          />,
        ]}
      />
    </>
  );
};

export default AnalyzerLinksFilterBar;
